import MyAccount from "../processes/MyAccount";

export const MyAccountRouter = MyAccount;
